import {FILTERS_FETCHED} from '../../actions/types';

export default function(state = [], action){
    switch (action.type){
        case FILTERS_FETCHED:
            return action.payload;
        default:
            break;
    }
    return state;
}


// WEBPACK FOOTER //
// ./src/reducers/Filters/index.js